module.exports = __webpack_public_path__ + "static/img/news15.df490c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news15.png
// module id = F/cE
// module chunks = 1